import MenuIcon from '@mui/icons-material/Menu';
import { Box, Link, Tooltip, useMediaQuery } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CSSObject, Theme, styled, useTheme } from '@mui/material/styles';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getDelayedDeviceCommunicationsCount } from 'app/entities/device-communication/device-communication.reducer';
import { getDelayedInspectionsCount } from 'app/entities/inspection-history/inspection-history.reducer';
import { ModalTestNewModules } from 'app/shared/components/modal-test-new-modules/ModalTestNewModules';
import { useAppThemeContext } from 'app/shared/contexts/ThemeContext';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { Translate } from 'react-jhipster';
import { useHistory } from 'react-router-dom';
import { Home } from '../header/header-components';
import { AccountMenu, AdminMenu } from '../menus';
import { InspectionMenu } from '../menus/InspectionMenu';
import { Maintenance } from '../menus/Maintenance';
import { CompanyMenu } from '../menus/company';
import { DashboardMenu } from '../menus/dashboard';
import { Logout } from '../menus/logout/Logout';
import { RegistrationMenu } from '../menus/registration';
import { Tire } from '../menus/tire';
import { Indicators } from '../menus/Indicators';
import { ReportsMenu } from '../menus/ReportsMenu';
import { Assets } from '../menus/assets';
import { FifthWheel } from '../menus/fifthWheel';
import { ScheduingMenu } from '../menus/SchedulingMenu';
import { ControlTower } from '../menus/ControlTower';
import { Drivers } from '../menus/Drivers';
import { verifyCanAccessClassification } from 'app/routes';
import { MapRoutesMenu } from '../menus/MapRoutesMenu';
import { isTireAuthorizedByCompany } from 'app/shared/auth/private-route';
import { CameraMenu } from '../menus/CameraMenu';

export interface IDrawerProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isManager: boolean;
  isManufacturerAdmin: boolean;
  isManufacturerManager: boolean;
  isManufacturerTechnician: boolean;
  isManufacturerUser: boolean;
  isTechnician: boolean;
  isDriver: boolean;
  isMaintenance: boolean;
  isMaintenanceByCompany: boolean;
  isTransporterAdmin: boolean;
  isTransporterDriver: boolean;
  isTransporterManager: boolean;
  istransporterUser: boolean;
  isRepresentativeAdmin: boolean;
  isOpenAPIEnabled: boolean;
  currentLocale: string;
  open: boolean;
  setOpen: (value: boolean) => void;
}

const drawerWidth = 310;

const openedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: theme.palette.primary.main,
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: theme.palette.primary.main,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('md')]: {
    width: `calc(${theme.spacing(11)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export const DefaultDrawer = (props: IDrawerProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const theme = useTheme();
  useAppThemeContext();
  const localInspectionModalNews = window.localStorage.getItem('InspectionModalNews') === 'true' ? false : true;
  const localMaintenceModalNews = window.localStorage.getItem('MaintenceModalNews') === 'true' ? false : true;
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;
  const [inspectionNews, setInspectionNews] = React.useState(false);
  const [maintenceNews, setMaintenceNews] = React.useState(false);
  const [expandedIndex, setExpandedIndex] = React.useState(null);
  const isXsToMd = useMediaQuery(theme.breakpoints.between('xs', 'md'));
  const drawerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef(null);
  const logoImage = initialTheme === 'dark' ? '../../../content/images/logo_2026_sigaway.svg' : '../../../content/images/logomarca-sigaway-dark.png';

  const handleDrawer = () => {
    props.setOpen(!props.open);
  };

  const handleLogoClick = () => {
    history.push('/dashboards/company/truck-implements');
  };

  const HandleInspectionModal = () => {
    if (localInspectionModalNews === true) {
      setInspectionNews(!inspectionNews);
      localStorage.setItem('InspectionModalNews', 'true');
    }
  };

  const HandleMaintenceModal = () => {
    if (localMaintenceModalNews === true) {
      setMaintenceNews(!maintenceNews);
      localStorage.setItem('MaintenceModalNews', 'true');
    }
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        if (!event.target.closest('svg') && !event.target.classList.contains('drawer-not-close') && !inspectionNews && !maintenceNews) {
          props.setOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [inspectionNews, maintenceNews, props]);

  useEffect(() => {
    if (!props.open) {
      setExpandedIndex(null);
    }
  }, [props.open]);

  const handleItemClick = index => {
    setExpandedIndex(prevIndex => (prevIndex === index ? null : index));
    !props.open && props.setOpen(true);
  };

  useEffect(() => {
    if (props.isAdmin || props.isTransporterAdmin) {
      dispatch(getDelayedInspectionsCount());

      if (props.isAdmin) {
        dispatch(getDelayedDeviceCommunicationsCount());
      }
    }
  }, [props.isAdmin, props.isTransporterAdmin]);

  const companyId = useAppSelector(state => state.authentication.account.company?.id);

  return (
    <>
      <Drawer
        anchor="left"
        variant="permanent"
        open={props.open}
        ref={drawerRef}
        sx={{
          display: props.open ? 'flex' : isXsToMd ? 'none' : 'block',
        }}
      >
        <DrawerHeader onClick={() => handleLogoClick()}>
          <img src={logoImage} className="logo-sigaway" alt="Logomarca Sigaway" style={{ height: '24px', cursor: 'pointer' }} />
        </DrawerHeader>

        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
          <List ref={listRef}>
            <ListItemButton
              onClick={handleDrawer}
              sx={{
                pl: { xs: '18px', md: '32px' },
              }}
            >
              <ListItemIcon aria-label="open drawer">
                <MenuIcon />
              </ListItemIcon>
              <ListItemText
                primary={<Translate contentKey="global.menu.menu">Menu</Translate>}
                primaryTypographyProps={{
                  fontSize: '14px',
                }}
                sx={{
                  opacity: props.open ? 1 : 0,
                  fontWeight: props.open ? '600' : '400',
                }}
              />
            </ListItemButton>

            {/* Reactivate with the arrival of the home screen */}
            {/* {props.isAuthenticated && <Home drawerIsOpen={props.open} />} */}

            {props.isAuthenticated &&
              // verifyCanAccessClassification() &&
              (props.isAdmin || props.isRepresentativeAdmin || props.isTransporterAdmin || props.isManufacturerAdmin) && (
                <ControlTower
                  isAdmin={props.isAdmin}
                  isManufacturerAdmin={props.isManufacturerAdmin}
                  isTransporterAdmin={props.isTransporterAdmin}
                  isRepresentativeAdmin={props.isRepresentativeAdmin}
                  index={0}
                  isExpanded={expandedIndex === 0}
                  onExpand={handleItemClick}
                  setOpen={props.setOpen}
                  drawerIsOpen={props.open}
                />
              )}

            {props.isAuthenticated && (props.isAdmin || props.isRepresentativeAdmin || props.isTransporterAdmin || props.isManufacturerAdmin) && (
              <Drivers
                isAdmin={props.isAdmin}
                isManufacturerAdmin={props.isManufacturerAdmin}
                isTransporterAdmin={props.isTransporterAdmin}
                isRepresentativeAdmin={props.isRepresentativeAdmin}
                index={14}
                isExpanded={expandedIndex === 14}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )}

            {props.isAuthenticated && <MapRoutesMenu drawerIsOpen={props.open} />}

            {props.isAuthenticated && <Assets drawerIsOpen={props.open} />}

            {props.isAuthenticated && (props.isAdmin || props.isRepresentativeAdmin || props.isTransporterAdmin || props.isManufacturerAdmin) && (
              <CompanyMenu
                isAdmin={props.isAdmin}
                isManufacturerAdmin={props.isManufacturerAdmin}
                isTransporterAdmin={props.isTransporterAdmin}
                isRepresentativeAdmin={props.isRepresentativeAdmin}
                index={1}
                isExpanded={expandedIndex === 1}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )}

            <CameraMenu
              isAuthenticated={props.isAuthenticated}
              isAdmin={props.isAdmin}
              isTransporterAdmin={props.isTransporterAdmin}
              index={3}
              isExpanded={expandedIndex === 3}
              onExpand={handleItemClick}
              setOpen={props.setOpen}
              drawerIsOpen={props.open}
            />

            {props.isAuthenticated && (props.isAdmin || props.isTransporterAdmin || props.isManufacturerAdmin) && (
              <Indicators
                isAdmin={props.isAdmin}
                isManufacturerAdmin={props.isManufacturerAdmin}
                isTransporterAdmin={props.isTransporterAdmin}
                index={2}
                isExpanded={expandedIndex === 2}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )}
            {props.isAuthenticated && (props.isAdmin || props.isRepresentativeAdmin || props.isTransporterAdmin || props.isManufacturerAdmin) && (
              <ReportsMenu index={4} isExpanded={expandedIndex === 4} onExpand={handleItemClick} setOpen={props.setOpen} drawerIsOpen={props.open} />
            )}
            {/* {props.isAuthenticated && (
              <DashboardMenu
                isDriver={props.isDriver}
                index={0}
                isExpanded={expandedIndex === 0}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )} */}

            {props.isAuthenticated && (props.isAdmin || props.isMaintenance || props.isTransporterAdmin) && (
              <Box onClick={HandleInspectionModal}>
                <InspectionMenu index={5} isExpanded={expandedIndex === 5} onExpand={handleItemClick} setOpen={props.setOpen} drawerIsOpen={props.open} />
                <ModalTestNewModules newsOpens={inspectionNews} setNewsOpen={setInspectionNews} module={'inspection'} />
              </Box>
            )}
            {props.isAuthenticated && !props.isRepresentativeAdmin && (
              <Box>
                <ScheduingMenu index={6} isExpanded={expandedIndex === 6} onExpand={handleItemClick} setOpen={props.setOpen} drawerIsOpen={props.open} />
              </Box>
            )}
            {props.isAuthenticated && (props.isAdmin || props.isMaintenance || props.isTransporterAdmin) && (
              <Box onClick={HandleMaintenceModal}>
                <Maintenance index={7} isExpanded={expandedIndex === 7} onExpand={handleItemClick} setOpen={props.setOpen} drawerIsOpen={props.open} />
                <ModalTestNewModules newsOpens={maintenceNews} setNewsOpen={setMaintenceNews} module={'maintenance'} />
              </Box>
            )}
            {/* {props.isAuthenticated && props.isAdmin && (
              || props.isManufacturerAdmin
              || props.isTransporterAdmin
              <CamMenu
                isAdmin={props.isAdmin}
                index={6}
                isExpanded={expandedIndex === 6}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )} */}
            {props.isAuthenticated && (props.isAdmin || (props.isTransporterAdmin && isTireAuthorizedByCompany(companyId))) && (
              <Tire index={8} isExpanded={expandedIndex === 8} onExpand={handleItemClick} setOpen={props.setOpen} drawerIsOpen={props.open} />
            )}
            {props.isAuthenticated && props.isAdmin && (
              <FifthWheel index={9} isExpanded={expandedIndex === 9} onExpand={handleItemClick} setOpen={props.setOpen} drawerIsOpen={props.open} />
            )}
            {props.isAuthenticated && props.isAdmin && (
              <RegistrationMenu
                isAdmin={props.isAdmin}
                index={10}
                isExpanded={expandedIndex === 10}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )}
            {props.isAuthenticated && props.isAdmin && (
              <AdminMenu
                isAdmin={props.isAdmin}
                showOpenAPI={props.isOpenAPIEnabled}
                index={11}
                isExpanded={expandedIndex === 11}
                onExpand={handleItemClick}
                setOpen={props.setOpen}
                drawerIsOpen={props.open}
              />
            )}
          </List>

          <Box sx={{ flexGrow: 1 }} />

          <List>
            <AccountMenu
              isAuthenticated={props.isAuthenticated}
              index={12}
              isExpanded={expandedIndex === 12}
              onExpand={handleItemClick}
              setOpen={props.setOpen}
              drawerIsOpen={props.open}
            />

            <Logout
              isAuthenticated={props.isAuthenticated}
              index={13}
              isExpanded={expandedIndex === 13}
              onExpand={handleItemClick}
              setOpen={props.setOpen}
              drawerIsOpen={props.open}
            />

            {!!props.open && expandedIndex === null && (
              <ListItemButton
                component={Link}
                href="https://www.sigaway.com.br/"
                target="_blank"
                sx={{
                  pl: { xs: '18px', md: '32px' },
                }}
              >
                <ListItemText
                  primary="sigaway.com.br"
                  primaryTypographyProps={{
                    fontSize: '14px',
                    color: '#999999',
                  }}
                />
              </ListItemButton>
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
